<div class="modal-header">
  <h4 class="modal-title" id="update-product-image-title">{{ product.name }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <amplify-s3-image-picker headerTitle="Update Product Image" buttonText="Update" track></amplify-s3-image-picker>
</div>